import { TenantBankAccount } from '@services';
import { useStore } from '@stores';
import { useEffect } from 'react';

declare const abp: any;

export const useTenantBankAccount = (): {
  tenantBankAccount: TenantBankAccount;
  loading: boolean;
} => {
  const { tenantStore } = useStore();
  const { tenantBankAccount, loading } = tenantStore;

  const id = abp?.session?.tenantId;

  useEffect(() => {
    id && tenantStore.getBankAccount({ id });
  }, [tenantStore, id]);

  return { tenantBankAccount, loading };
};
